<template>
  <div id="contenedor-main-expediente-contrato-estimaciones">
      <expediente
      :idReferencia="idReferencia"
      moduloExpedienteOrigen="contratos"
      soloLectura>
      </expediente>
  </div>
</template>

<script>
import Expediente from '@/views/administracion/expedientes/Main.vue';

export default {
  name: 'ExpedienteContratoEstimacionesMain',
  components: {
    Expediente,
  },
  data() {
    return {
      idReferencia: this.$route.params.idContrato,
    };
  },

};
</script>

<style>

</style>
